import React from 'react'
import { NotificationDto, NotificationRow } from '../../../../services/api.types'
import { t } from 'ttag'
import './AnnouncementStatus.scss'

interface ITeamStatus {
  notification: NotificationDto
}

export default function AnnouncementStatus(props: ITeamStatus) {
  const { notification } = props
  const { sent, readBy: x } = notification
  const BEM = () => {
    const classArray = ['announcement-status']

    if (sent) {
      classArray.push('announcement-status__sent')
    } else {
      classArray.push('announcement-status__unsent')
    }

    return classArray.join(' ')
  }
  return (
    <div className={`announcement-status announcement-status__${BEM()}`}>
      <span className="announcement-status-dot"></span>
      {sent ? (
        <>
          {/*{t`Sent`} &middot;*/} {t`Read by ${x} users`}
        </>
      ) : (
        t`Unsent`
      )}
    </div>
  )
}
